/*
* Copyright (c) Akveo 2019. All Rights Reserved.
* Licensed under the Single Application / Multi Application License.
* See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
*/
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TokenStorageService } from './token-storage.service';
import { takeUntil } from 'rxjs/operators';
const API_URL = environment.apiUrl + 'contest';
const CONTEST_MATCH_STATS_API_URL = environment.apiUrl + 'contest-match-stats';
@Injectable(
    {
        providedIn: "root"
    }
)
export class ContestService {
    authtoken: string;
    private httpOptions;
    constructor(private http: HttpClient, private token: TokenStorageService) {
        this.authtoken = this.token.getToken();
        this.httpOptions = {
            headers: new HttpHeaders()
                .set("Content-Type", "application/json")
                .set('Authorization', `Bearer ${this.authtoken}`)
        };
    }
    getContestList(query): Observable<any> {
        return this.http.get<any>(API_URL + query, this.httpOptions);
    }
    /* getContestListWithoutAuth(query): Observable<any> {
        return this.http.get<any>(API_URL + '/v1' + query, this.httpOptions);
    } */
    private cancelPreviousCalls$ = new Subject<void>();
    getContestListWithoutAuth(query: string): Observable<any> {
        // Cancel any ongoing request
        this.cancelPreviousCalls$.next();
    
        const url = API_URL + '/v1' + query;
    
        // Create a new request and ensure it's cancellable
        return this.http.get<any>(url, this.httpOptions).pipe(
            takeUntil(this.cancelPreviousCalls$)
        );
    }
    getContestDetails(id: string) {
        return this.http.get<any>(`${API_URL}/${id}`, this.httpOptions);
    }
    addContest(questionAnswer) {
        return this.http.post<any>(API_URL, questionAnswer, this.httpOptions);
    }
    updateContest(id: string, questionAnswer): Observable<any> {
        return this.http.put(API_URL + '/' + id, questionAnswer, this.httpOptions);
    }

    getContestMatchStats(query) {
        return this.http.get<any>(CONTEST_MATCH_STATS_API_URL + query, this.httpOptions);
    }

    getContestMatchSetPoints(matchId) {
        return this.http.get<any>(environment.apiUrl + 'user-contest/setpoints/'+matchId, this.httpOptions);
    }

    addDownloadMoneyContestAppHitCount(body:any) {
        return this.http.post(environment.apiUrl + 'downloadapp', body);
    }

    getDownloadMoneyContestAppHitCount() {
        return this.http.get(environment.apiUrl + 'downloadapp/v1/');
    }

}
